import { Injectable } from '@angular/core';
import { CommonServiceModule } from 'src/app/common-service/common-service.module';
import { ServerURLService } from 'src/app/common-service/serverURL.service';


@Injectable({
    providedIn: CommonServiceModule
})
export class PtrServices {
    constructor(public serverURL: ServerURLService) { }
   
    registerUser=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/applicant-registration`;
    updateRegistration=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/updateRegistration`;
    updatePaymentDetails=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/updatePaymentDetails`;
    updateBySecExecutive=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/updateBySecExecutive`;
    updateBySecHead=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/updateBySecHead`;
    applicantSignUp=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/applicant-signup`;    
    institutionTypeList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/master-data/auth/getInstitutionTypeList`;
    countryList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/master-data/auth/getAllCountrys`;
    stateList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/master-data/auth/getStates`;
    cityList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/master-data/auth/getCity`;
    getUserDetails=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getUserDetails`;
    getUserDetailsById=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getUserDetailsById`;  
    getUserDetailsByEmail=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getUserDetailsByEmail`; 
    getuserDetailsByCollege=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getUserDetailsByCollege`; 
    getApplicationList=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getApplicationList`; 
    getRegDraftDetails=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getRegDraftDetails`;    
    applicantFileUpload=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/fileUpload`;    
    saveRegistrationDraft=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/saveDraft`;    
    preview = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/preview/`;
    downloadUploadFIle = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/downloadUploadFIle`;
    getAcceptanceLetterPdf=`${this.serverURL.apiServerAddress}dci-ptr/api/v1/user/getAcceptanceLetterPdf`; 

    getAllInstitutionAndCollegePtrApplicationlist = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getAllInstitutionAndCollegePtrApplicationlist`;
    getAllSectionHeadPtrApplicationList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getAllSectionHeadPtrApplicationList`;
    getAllSectionExecutivePtrApplicationList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getAllSectionExecutivePtrApplicationList`;
    getAllTrackPtrApplicationList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getAllTrackPtrApplicationList`;

    getAllPtrStatusList = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getAllPtrStatusList`;
    getPtrProcessHistory = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getPtrProcessHistory`;
    ptrApplicationSeekApprovalReturnForCorrection = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/ptrApplicationSeekApprovalReturnForCorrection`;
    ptrApplicationReSubmit = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/ptrApplicationReSubmit`;
  
    updatePtrApplicationWorkflow = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/update_ptrApplication_workflow`;
    getPtrApplicationViewExportPdf = `${this.serverURL.apiServerAddress}dci-ptr/api/v1/ptr/getPtrApplicationView_exportPdf`;
    

}
export const urlServiceProvider = [
    PtrServices
];
